<script setup lang="ts">
import { LOCALE } from "core/interfaces";

import { getKindLinks } from "~/common/helpers/get-kind-links";

defineEmits(["click:link"]);

const { locale } = useI18n();
const shopStore = useShopStore();

const links = computed(() => getKindLinks(locale.value as LOCALE, shopStore.components.kinds));
</script>

<template>
	<nav>
		<ul class="flex items-center gap-x-6 gap-y-4 px-5 sm:flex-col xs:flex-col sm:items-start xs:items-start sm:px-0 xs:px-0">
			<LayoutHeaderNavItem
				link="/"
				@click:link="$emit('click:link')"
			>
				{{ $t('home') }}
			</LayoutHeaderNavItem>
			<LayoutHeaderNavItem
				v-for="{id, name, link} in links"
				:key="`kind:${id}`"
				:link="link"
				@click:link="$emit('click:link')"
			>
				{{ name }}
			</LayoutHeaderNavItem>
			<LayoutHeaderNavItem
				v-for="{id, name} in shopStore.components.tags"
				:key="`tag:${id}`"
				:link="{
					path: '/shop',
					query: { tags: id }
				}"
				:use-active-class="false"
				@click:link="$emit('click:link')"
			>
				{{ name }}
			</LayoutHeaderNavItem>
		</ul>
	</nav>
</template>
